export default __webpack_public_path__ + "static/media/errorIcon.50199ce6.svg";